import { getDefaultFilterFn } from './commonListTableDefaults';

import type { SystemsTableFilter } from '../types/pipesList.types';

export const filterLabelMapping = {
  _id: 'System',
  origin: 'Origin',
  tags: 'Tags',
  type: 'Type',
  name: 'Name',
  configGroup: 'Config group',
  systemGroup: 'System group',
  tenant: 'Tenant',
};

export const emptyFilterSystems: SystemsTableFilter = Object.freeze({
  _id: {
    selected: [],
    search: [],
  },
  name: {
    selected: [],
    search: [],
  },
  type: {
    selected: [],
    search: [],
  },
  origin: {
    selected: [],
    search: [],
  },
  tags: {
    selected: [],
    search: [],
  },
  configGroup: {
    selected: [],
    search: [],
  },
  systemGroup: {
    selected: [],
    search: [],
  },
  tenant: {
    selected: [],
    search: [],
  },
});

export const defaultVisibleCols = ['System', 'Type', 'Config', 'Pipes in', 'Pipes out'];

export const defaultVisibleFacets = ['_id', 'type', 'origin', 'tags'];

export const defaultSortBy = [
  {
    id: 'systems-link',
    desc: false,
  },
];

export const getSystemsDefaultFilter = getDefaultFilterFn(emptyFilterSystems);
